/* eslint-disable import/prefer-default-export */
import React from 'react';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { saveTemplateFromVulnContext, showContextMenu } from 'store/Manage/actions';
import { useIntl } from 'react-intl';
import { SaveTemplateIcon } from './styled';
import { selectVulnsSelected } from 'store/Manage/selectors';

export const SaveAsTemplate = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const vulnsSelected = useSelector(selectVulnsSelected);

  return (
    <MenuItem
      title={ intl.formatMessage({ id: 'manage.cm.saveAsTemplate' }) }
      icon={ <SaveTemplateIcon /> }
      onClick={ () => {
        dispatch(saveTemplateFromVulnContext(vulnsSelected, 'vulns'));
        dispatch(showContextMenu(false));
      } }
    />
  );
};
